module.exports = __webpack_public_path__ + "img/8J.1d374b74.png";